import { CREATE_FAST_USER_SUCCESS, CREATE_FAST_USER_REQUEST, CREATE_FAST_USER_ERROR } from '../constants/ActionTypes';

export default function isCreatingFastUser(state = false, action) {
    switch (action.type) {
        case CREATE_FAST_USER_REQUEST:
            return true
        case CREATE_FAST_USER_SUCCESS:
        case CREATE_FAST_USER_ERROR:
            return false
        default:
            return state
    }
}
